import React from 'react';

const WorldClocks = ({ currentTime }) => {
  const cities = [
    { city: 'Dubai', tz: 'Asia/Dubai', flag: '🇦🇪', openHour: 10, openMin: 0, closeHour: 14, closeMin: 0 },       // DFM: 10:00 AM - 2:00 PM
    { city: 'Mumbai', tz: 'Asia/Kolkata', flag: '🇮🇳', openHour: 9, openMin: 15, closeHour: 15, closeMin: 30 },   // NSE: 9:15 AM - 3:30 PM
    { city: 'Hong Kong', tz: 'Asia/Hong_Kong', flag: '🇭🇰', openHour: 9, openMin: 30, closeHour: 16, closeMin: 0 }, // HKSE: 9:30 AM - 4:00 PM
    { city: 'Tokyo', tz: 'Asia/Tokyo', flag: '🇯🇵', openHour: 9, openMin: 0, closeHour: 15, closeMin: 0 },        // TSE: 9:00 AM - 3:00 PM
    { city: 'Dallas', tz: 'America/Chicago', flag: '🇺🇸', openHour: 8, openMin: 30, closeHour: 15, closeMin: 0 }, // US markets in CT: 8:30 AM - 3:00 PM CT
    { city: 'New York', tz: 'America/New_York', flag: '🇺🇸', openHour: 9, openMin: 30, closeHour: 16, closeMin: 0 }, // NYSE: 9:30 AM - 4:00 PM ET
    { city: 'London', tz: 'Europe/London', flag: '🇬🇧', openHour: 8, openMin: 0, closeHour: 16, closeMin: 30 },   // LSE: 8:00 AM - 4:30 PM
    { city: 'Zurich', tz: 'Europe/Zurich', flag: '🇨🇭', openHour: 9, openMin: 0, closeHour: 17, closeMin: 30 },   // SIX: 9:00 AM - 5:30 PM
    { city: 'Moscow', tz: 'Europe/Moscow', flag: '🇷🇺', openHour: 9, openMin: 50, closeHour: 18, closeMin: 50 },  // MOEX: 9:50 AM - 6:50 PM
  ];

  return (
    <div className="absolute top-36 left-52 right-64 flex justify-center gap-4 z-10">
      {cities.map((loc) => {
        const time = currentTime.toLocaleTimeString('en-US', {
          timeZone: loc.tz,
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
        const [hourStr, minStr] = time.split(':');
        const hour = parseInt(hourStr);
        const min = parseInt(minStr);
        const totalMins = hour * 60 + min;
        const openMins = loc.openHour * 60 + loc.openMin;
        const closeMins = loc.closeHour * 60 + loc.closeMin;
        
        // Check if market is open (also check for weekends)
        const dayOfWeek = new Date(currentTime.toLocaleString('en-US', { timeZone: loc.tz })).getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
        const isOpen = !isWeekend && totalMins >= openMins && totalMins < closeMins;
        
        return (
          <div key={loc.city} className="flex flex-col items-center bg-slate-800/80 rounded px-2 py-1 border border-slate-700">
            <span className="text-[10px] text-slate-400">{loc.flag} {loc.city}</span>
            <span className={`text-sm font-mono font-bold ${isOpen ? 'text-emerald-400' : 'text-slate-300'}`}>
              {time}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default WorldClocks;
